import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import ClassService from './ClassService';

import schema from './jsonSchema';
const jsonSchema = schema;
  const mergeSchema = (formSchema, isEmptyForm) => {
  console.log("isEmptyForm", isEmptyForm);
  if(!isEmptyForm){
    return formSchema;
  }
  return formSchema.map((f)=>{
    if(f.name === 'name'){
      return {...f, type: 'text'}
    }
    return f;
  })

};
const formatTime = timeValue => {
  // If timeValue is already in HH:MM format, return it
  if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}$/)) {
    return timeValue;
  }

  // Handle time as array [hours, minutes]
  if (Array.isArray(timeValue)) {
    const [hours, minutes] = timeValue;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
      2,
      '0'
    )}`;
  }

  // Otherwise, try to parse it as a date/time
  const date = new Date(timeValue);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`;
};
const formatDate = dateValue => {
  let date;

  // Handle date as array [year, month, day]
  if (Array.isArray(dateValue)) {
    const [year, month, day] = dateValue;
    date = new Date(year, month - 1, day);
  } else {
    date = new Date(dateValue);
  }

  // Format as DD/MM/YYYY
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  //return `${day}/${month}/${year}`;
  return `${year}-${month}-${day}`;
};
const WODClassForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [isEmptyForm, setIsEmptyForm] = useState(true);
  useEffect(() => {
    if (undefined !== identifier) {
      ClassService.retrieveClass(identifier)
        .then(data => {
          const updatedData = {
            ...data,
            date: formatDate(data.date),
            startTime: formatTime(data.startTime),
            endTime: formatTime(data.endTime),
            name: { label: data.name, value: data.name }
          };
          setData(updatedData);
          setIsEmptyForm(false);
        })
        .catch(error => console.log(error));
    }
  }, [identifier]);

  const handleWODClassFormSubmit = formData => {
    console.log('Form data to submit:', formData);
    ClassService.updateClass(formData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save WODClass',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save WODClass');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
    const title = identifier ? 'Edit Class' : 'Create Class';
  const headerGenerated = useHeaderGenerator(title, ' ', []);

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'WODClass  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/app/wod/admin/classes"
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleWODClassFormSubmit}
              isEmpty={isEmptyForm}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit, isEmpty }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    mergeSchema(jsonSchema, isEmpty),
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default WODClassForm;
